import React, { useState } from 'react';

import { PHOTOS_PER_RESTAURAUNT } from '../../constans/pagination';
import IconAllPhotos from '../../assets/img/icons/ic-photos.svg';
import styles from './PropertyRestaurant.module.scss';

const PropertyRestaurant = ({
  title, photos, description, className, foodImageStyles,
}) => {
  const [limit, setLimit] = useState(PHOTOS_PER_RESTAURAUNT);

  const handleShowMoreClick = () => setLimit(
    limit === photos?.length ? PHOTOS_PER_RESTAURAUNT : photos.length,
  );

  return (
    <div className={className}>
      <div className={styles.restaurantTitleWrapper}>
        <div className={styles.restaurantTitle}>
          {title}
        </div>
        {!!(photos?.length > PHOTOS_PER_RESTAURAUNT) && (
          <button type="button" className={styles.toggler} onClick={handleShowMoreClick}>
            <IconAllPhotos />
          </button>
        )}
      </div>
      <div className={styles.restaurantImageList}>
        {photos?.slice(0, limit).map(({ file }) => (
          <div className={`${styles.restaurantImageWrapper} ${foodImageStyles}`} key={file.id}>
            <img className={styles.restaurantImage} src={file.link} alt={file.id} />
          </div>
        ))}
      </div>
      <div className={styles.restaurantDescr}>
        {description}
      </div>
    </div>
  );
};

PropertyRestaurant.defaultProps = {
  foodImageStyles: '',
};

export default PropertyRestaurant;
